import { render, staticRenderFns } from "./OfficeWordIcon.vue?vue&type=template&id=8636ede4"
import script from "./OfficeWordIcon.vue?vue&type=script&lang=js"
export * from "./OfficeWordIcon.vue?vue&type=script&lang=js"
import style0 from "./OfficeWordIcon.vue?vue&type=style&index=0&id=8636ede4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports